import { useMutation } from '@tanstack/react-query';
import { stringify as toQueryString } from '@AppModels/QueryStringUtils';
import { useApiClientContext } from '../../surveys/context';
import { IOperationResultNoValue } from '../../surveys/models/Api';

/** A signed url for one file on a secure download link, as seen by the link's recipient. */
export const useSharedFileLinkDownloadUrlMutation = () => {
	const { apiClient } = useApiClientContext();
	return useMutation<string, IOperationResultNoValue, { attachmentId: string; token: string }>({
		mutationFn: ({ attachmentId, token }) =>
			apiClient.get<string>(
				`sharedFileLink/byToken/attachment/${encodeURIComponent(attachmentId)}?${toQueryString({ token })}`
			),
	});
};
